export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY || '';
